import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { tsdaBaseQuery } from './baseQuery';

export const subjectToolkitAPI = createApi({
  baseQuery: tsdaBaseQuery,
  reducerPath: 'SubjectToolkitAPI',
  endpoints: builder => ({
    getSubjectToolkitForms: builder.query<any, any>({
      query: ({ site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.PatientTrialNotebookAPI.getSubjectToolKitForms
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        method: 'GET'
      })
    }),
    assignToSubject: builder.mutation<any, any>({
      query: ({ data, parent_id, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.PatientTrialNotebookAPI.assignSubject,
          { key: urlKeys.parent_id, value: parent_id },
          { key: urlKeys.study_id, value: study_id }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        method: 'Post',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getAssignedForms: builder.mutation<any, any>({
      query: ({ parent_id, site_id, study_id, country, from, size, data }) => ({
        url: `${formatString(
          endPoints.PatientTrialNotebookAPI.getAssignedForms,
          {
            key: urlKeys.parent_id,
            value: encodeURIComponent(parent_id)
          },
          { key: urlKeys.study_id, value: study_id }
        )}?${from ? `from=${from}&` : ``}${
          size ? `size=${size}&` : ``
        }site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        method: 'POST',
        body: data
      })
    }),
    getLatestSubjectID: builder.mutation<any, any>({
      query: ({ study_id, country, site_id }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.getLatestSubjectID,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.country,
            value: country
          },
          {
            key: urlKeys.site_id,
            value: site_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        method: 'GET'
      })
    }),
    generateSubjectID: builder.mutation<any, any>({
      query: ({ data, parent_id, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.generateSubjectID,
          { key: urlKeys.parent_id, value: parent_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.country, value: country }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        method: 'Post',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    activateCRF: builder.mutation<any, any>({
      query: ({ data, parent_id, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.activateCRF,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.parent_id,
            value: parent_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'PUT'
      })
    }),
    enrollSubject: builder.mutation<any, any>({
      query: ({ data, parent_id, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.enrollSubject,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.parent_id,
            value: parent_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'POST'
      })
    }),

    PreTrialEvaluation: builder.mutation<any, any>({
      query: ({ data, parent_id, site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.toolkitFormsAPI.preTrialEvaluation,
          {
            key: urlKeys.study_id,
            value: study_id
          },
          {
            key: urlKeys.site_id,
            value: site_id
          },
          {
            key: urlKeys.patient_id,
            value: parent_id
          }
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=TSDA&application_section=TSDA&application_module_section=${`PATIENT TRIAL NOTEBOOK`}`,
        body: data,
        method: 'Post'
      })
    })

    //Pre-Trial Evaluation
  })
});

export const {
  useGetSubjectToolkitFormsQuery,
  useAssignToSubjectMutation,
  useGetAssignedFormsMutation,
  useGetLatestSubjectIDMutation,
  useGenerateSubjectIDMutation,
  useActivateCRFMutation,
  useEnrollSubjectMutation,
  usePreTrialEvaluationMutation
} = subjectToolkitAPI;
